import { render, staticRenderFns } from "./WChipList.vue?vue&type=template&id=84cfc9be&scoped=true&"
import script from "./WChipList.vue?vue&type=script&lang=js&"
export * from "./WChipList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cfc9be",
  null
  
)

export default component.exports